import _eol from "eol";
const eol = _eol;
/* Takes plaintext with no formatting */
export default (function getLongestLine(text) {
  return eol.split(text).sort((lineA, lineB) => {
    return lineB.length - lineA.length;
  })[0];
});